
 let leftTop = 100;
 
 function getScaledObject(obj) {
  let maxSize = 200;
  const scaleX = maxSize / obj.width;
  const scaleY = maxSize / obj.height;
  const scale = Math.min(scaleX, scaleY);
  obj.scale(scale);
  return obj;
}
 
export const dataHandlers = {
  font: (data, canvas, customProps) => {
    const font = JSON.parse(data);
   
    const text = new fabric.IText(font.name ||font.family || font.font_family, {
      fontFamily: font.family || font.font_family || font.name  ,
      
      left: customProps?.left ?? leftTop,
      top: customProps?.top ?? leftTop,
      originX: "center",
      originY: "center",
      fontSize: 50,
               
      
    });
    text.on('editing:entered', () => {
      const ta = text.hiddenTextarea;
      const handler = e => {
        if (e.key === ' ') {
          e.preventDefault();
    
          // 1) get the cursor index
          const cursorPos = ta.selectionStart;
          // 2) splice a single space into the Fabric text
          const before = text.text.slice(0, cursorPos);
          const after  = text.text.slice(cursorPos);
          const newText = before + ' ' + after;
    
          // 3) update both Fabric and the native textarea
          text.text = newText;
          ta.value = newText;
          ta.selectionStart = ta.selectionEnd = cursorPos + 1;
    
          // 4) re-measure & re-render
          text.initDimensions();
          text.setCoords();
          canvas.renderAll();
        }
      };
    
      ta.addEventListener('keydown', handler);
    
      // clean up when you exit editing
      text.once('editing:exited', () => {
        ta.removeEventListener('keydown', handler);
      });
    });
    text.on('changed', () => {
      const ctx = canvas.getContext(); 
      ctx.font = `${text.fontSize}px ${text.fontFamily}`;
      
     
      const measured = ctx.measureText(text.text);
      const actualWidth = measured.width;
    
     
      text.set({
        width: actualWidth + 2, 
        dirty: true,
      });
    
      text.initDimensions();  
      text.setCoords();      
      canvas.renderAll();
    });
    
    canvas.add(text);
    canvas.renderAll();
  },
  image: (data, canvas, customProps) => {
    return new Promise((resolve, reject) => {
      try {
        fabric.Image.fromURL(data, (img) => {
          getScaledObject(img);

          img.set({
            left: customProps?.left ?? leftTop,
            top: customProps?.top ?? leftTop,
            originX: "center",
            originY: "center",
          });
          canvas.add(img);
          canvas.renderAll();
          resolve(img);
        },{ crossOrigin: "anonymous" });
      } catch (err) {
        reject(err?.message);
      }
    });
  },

svg: (data, canvas, customProps) => {
 
  
  fabric.loadSVGFromURL(data, (objects, options) => {
    const svgGroup = fabric.util.groupSVGElements(objects, options);

 
    getScaledObject(svgGroup);
    svgGroup.set({
      perPixelTargetFind:true,
      left: customProps?.left ?? leftTop,
      top: customProps?.top ?? leftTop,
      originX: "center",
      originY: "center",
    }).setCoords();
    canvas.add(svgGroup);
    canvas.renderAll();

    //code for ungroup start
     
    const items = svgGroup._objects;
    svgGroup._restoreObjectsState();
    canvas.remove(svgGroup);
    items.forEach(obj => {
      if (customProps?.isPremium) {
        obj.isPremium = true;
      }
      canvas.add(obj);
    });

    canvas.renderAll();
// end 
  });
},

svgFile: (file, canvas, customProps = {}) => {
  
  if (!file) return;
  const reader = new FileReader();
  reader.onload = function (e) {
    const svgString = e.target.result; // SVG content as a string
    fabric.loadSVGFromString(svgString, (objects, options) => {
      const group = fabric.util.groupSVGElements(objects, options);
    
      getScaledObject(group);

      group.set({
        perPixelTargetFind:true,
        left: customProps.left ?? leftTop,
        top: customProps.top ?? leftTop,
        originX: "center",
        originY: "center",
      }).setCoords();
      
      canvas.add(group);
      canvas.renderAll();
        //code for ungroup start
     
    const items = group._objects;
    group._restoreObjectsState();
    canvas.remove(group);
    items.forEach(obj => {
   
      canvas.add(obj);
    });

    canvas.renderAll();
// end 
    });
  };
  reader.readAsText(file);
},

};

